import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NativeDownloadToastBridge from './components/common/NativeDownloadToastBridge';
import NativePushBridge from './components/common/NativePushBridge';
import BiometricLockScreen from './components/auth/BiometricLockScreen';


import CodeMngPage from './pages/codemng/CodeMngPage';
import FieldConfigPage from './pages/fieldconfigmng/FieldConfigPage';
import CompanyInfoPage from './pages/companyinfomng/CompanyInfoPage';
import SysJobsPage from './pages/sysjobs/SysJobsPage';
import EmployeeListPage from './pages/employeemng/EmployeeListPage';
import EmployeeMngPage from './pages/employeemng/EmployeeMngPage';

import LoginPage from './pages/login/LoginPage';
import MainPage from './pages/main/MainPage';
import PartnerAddPage from './pages/partnermng/PartnerAddPage';
import PartnerEditPage from './pages/partnermng/PartnerEditPage';
import PartnerListPage from './pages/partnermng/PartnerListPage';
import PartnerMngPage from './pages/partnermng/PartnerMngPage';
import ProductAddPage from './pages/productmng/ProductAddPage';
import ProductListPage from './pages/productmng/ProductListPage';
import ProductMngPage from './pages/productmng/ProductMngPage';

import ProductEditPage from './pages/productmng/ProductEditPage';
import ChanceMngPage from './pages/chancemng/ChanceMngPage';
import ChanceListPage from './pages/chancemng/ChanceListPage';
import EmployeeAddPage from './pages/employeemng/EmployeeAddPage';
import EmployeeEditPage from './pages/employeemng/EmployeeEditPage';
import PaymentMngPage from './pages/paymentmng/PaymentMngPage';
import BillFlowMngPage from './pages/billflow/BillFlowMngPage';
import BillFlowListPage from './pages/billflow/BillFlowListPage';
import BillFlowDetailPage from './pages/billflow/BillFlowDetailPage';

import TaxbillMngPage from './pages/taxbillmng/TaxbillMngPage';
import TaxbillListPage from './pages/taxbillmng/TaxbillListPage';
import BillCollectListPage from './pages/billcollect/BillCollectListPage';
import TaxbillAddPage from './pages/taxbillmng/TaxbillAddPage';
import TaxbillEditPage from './pages/taxbillmng/TaxbillEditPage';
import PartnerViewPage from './pages/partnermng/PartnerViewPage';
import ProductViewPage from './pages/productmng/ProductViewPage';
import EmployeeViewPage from './pages/employeemng/EmployeeViewPage';
import ProfileMngPage from './pages/profilemng/ProfileMngPage';
import ProfileViewPage from './pages/profilemng/ProfileViewPage';
import ProfileEditPage from './pages/profilemng/ProfileEditPage';
import TaxbillViewPage from './pages/taxbillmng/TaxbillViewPage';

import ChanceDetailPage from './pages/chancemng/ChanceDetailPage';
import ChanceByNoPage from './pages/chancemng/ChanceByNoPage';
import GroupListPage from './pages/chancemng/GroupListPage';
import GroupDetailPage from './pages/chancemng/GroupDetailPage';
import GoPage from './pages/common/GoPage';
import ChanceStepPage from './pages/chancemng/ChanceStepPage';
import TechMngPage from './pages/techmng/TechMngPage';

import TechStepPage from './pages/techmng/TechStepPage';
import TechProjectListPage from './pages/techmng/TechProjectListPage';
import TechProjectDetailPage from './pages/techmng/TechProjectDetailPage';

import ProjectMngPage from './pages/projectmng/ProjectMngPage';
import ProjectListPage from './pages/projectmng/ProjectListPage';
import ProjectDetailPage from './pages/projectmng/ProjectDetailPage';
import ProjectStepPage from './pages/projectmng/ProjectStepPage';

import MaintanceMngPage from './pages/maintancemng/MaintanceMngPage';
import MaintanceDetailPage from './pages/maintancemng/MaintanceDetailPage';
import MaintanceStepPage from './pages/maintancemng/MaintanceStepPage';

import ReqTechMngPage from './pages/reqtechmng/ReqTechMngPage';
import ReqTechListPage from './pages/reqtechmng/ReqTechListPage';
import ReqTechViewPage from './pages/reqtechmng/ReqTechViewPage';
import PlanTechMngPage from './pages/plantechmng/PlanTechMngPage';
import PlanTechListPage from './pages/plantechmng/PlanTechListPage';
import PlanTechViewPage from './pages/plantechmng/PlanTechViewPage';
import RsltTechMngPage from './pages/rslttechmng/RsltTechMngPage';
import RsltTechListPage from './pages/rslttechmng/RsltTechListPage';
import RsltTechViewPage from './pages/rslttechmng/RsltTechViewPage';
import DashboardMngPage from './pages/dashboard/DashboardMngPage';
import DashboardViewPage from './pages/dashboard/DashboardViewPage';
import DeptMngPage from './pages/deptmng/DeptMngPage';
import DeptViewPage from './pages/deptmng/DeptViewPage';
import ApprovalMngPage from './pages/approvalmng/ApprovalMngPage';
import ApprovalListPage from './pages/approvalmng/ApprovalListPage';
import ApprovalViewPage from './pages/approvalmng/ApprovalViewPage';
import ApprovalSubmittedPage from './pages/approvalmng/ApprovalSubmittedPage';
import ApprovalLineTemplatePage from './pages/approvalmng/ApprovalLineTemplatePage';
import ApprovalDelegationPage from './pages/approvalmng/ApprovalDelegationPage';
import ApprovalFinalAuthPage from './pages/approvalmng/ApprovalFinalAuthPage';
import DeptEditPage from './pages/deptmng/DeptEditPage';
import ScheduleMngPage from './pages/schedulemng/ScheduleMngPage';
import SalesSchedulePage from './pages/schedulemng/SalesSchedulePage';
import ManufacturingSchedulePage from './pages/schedulemng/ManufacturingSchedulePage';
import MenuMngPage from './pages/domain/MenuMngPage';
import FileSearchPage from './pages/filemng/FileSearchPage';
import MenuEditPage from './pages/domain/MenuEditPage';
import SaleGoalMngPage from './pages/salesgoalmng/SaleGoalMngPage';
import SaleGoalViewPage from './pages/salesgoalmng/SaleGoalViewPage';
import SaleGoalEditPage from './pages/salesgoalmng/SaleGoalEditPage';
import InventoryMngPage from './pages/inventorymng/InventoryMngPage';
import WarehouseListPage from './pages/inventorymng/WarehouseListPage';

import NoticeMngPage from './pages/noticemng/NoticeMngPage';
import EsgMngPage from './pages/esgmng/EsgMngPage';
import GoalSettingMngPage from './pages/goalsetting/GoalSettingMngPage';
import GoalSettingPage from './pages/goalsetting/GoalSettingPage';
import GoalDeptUserPage from './pages/goalsetting/GoalDeptUserPage';
import InventoryProductsPage from './pages/inventorymng/InventoryProductsPage';
import InventoryHistoryPage from './pages/inventorymng/InventoryHistoryPage';

import TaxIssuedMngPage from './pages/taxIssuedmng/TaxIssuedMngPage';
import TaxIssuedListPage from './pages/taxIssuedmng/TaxIssuedListPage';
import TaxIssuedAddPage from './pages/taxIssuedmng/TaxIssuedAddPage';
import TaxIssuedViewPage from './pages/taxIssuedmng/TaxIssuedViewPage';
import TaxIssuedEditPage from './pages/taxIssuedmng/TaxIssuedEditPage';
import PaymentListPage from './pages/paymentmng/PaymentListPage';
import PaymentAddPage from './pages/paymentmng/PaymentAddPage';
import PaymentViewPage from './pages/paymentmng/PaymentViewPage';
import PaymentEditPage from './pages/paymentmng/PaymentEditPage';
import ForecastMonthStatMngPage from './pages/forecastmonthstat/ForecastMonthStatMngPage';
import ForecastMonthStatViewPage from './pages/forecastmonthstat/ForecastMonthStatViewPage';
import ForecastStatMngPage from './pages/forcaststat/ForecastStatMngPage';
import ForecastStatViewPage from './pages/forcaststat/ForecastStatViewPage';
import ChanceAddPage from './pages/chancemng/ChanceAddPage';
import ChanceAddForecastPage from './pages/chancemng/ChanceAddForecastPage';
import ProjectDeptStatMngPage from './pages/project_dept_stat/ProjectDeptStatMngPage';
import ProjectDeptStatViewPage from './pages/project_dept_stat/ProjectDeptStatViewPage';
import VendorDeptStatMngPage from './pages/vendor_dept_stat/VendorDeptStatMngPage';
import VendorDeptStatViewPage from './pages/vendor_dept_stat/VendorDeptStatViewPage';
import ProjectDeptCountMngPage from './pages/project_dept_count/ProjectDeptCountMngPage';
import ProjectDeptCountViewPage from './pages/project_dept_count/ProjectDeptCountViewPage';
import MaintanceDeptStatMngPage from './pages/maintance_dept_stat/MaintanceDeptStatMngPage';
import MaintanceDeptStatViewPage from './pages/maintance_dept_stat/MaintanceDeptStatViewPage';
import GoalStaticsMngPage from './pages/goal_statics/GoalStaticsMngPage';
import GoalStaticsViewPage from './pages/goal_statics/GoalStaticsViewPage';
import BondDeptListPage from './pages/bonds-depts/BondsDeptsListPage';
import CollectBuyListPage from './pages/collects_buys/CollectBuyListPage';
import TaxbillStaticsMngPage from './pages/taxbill_statics/TaxbillStaticsMngPage';
import TaxbillStaticsViewPage from './pages/taxbill_statics/TaxbillStaticsViewPage';
import BondsDeptsStaticsViewPage from './pages/bonds-depts-statics/BondsDeptsStaticsViewPage';
import CollectsBuysStaticsViewPage from './pages/collects-buys-statics/CollectsBuysStaticsViewPage';
import EstimateStatusPage from './pages/estimate_status/EstimateStatusPage';
import OrderSheetStatusPage from './pages/order_sheet_status/OrderSheetStatusPage';
import CadQuotePage from './pages/cadquote/CadQuotePage';
import SalesmanStaticsViewPage from './pages/salesman-statics/SalesmanStaticsViewPage';
import SalesStaticsViewPage from './pages/sales-statics/SalesStaticsViewPage';
import ApprovalMonitorListPage from './pages/approval_monitoring/ApprovalMonitorListPage';
import ApprovalMonitorViewPage from './pages/approval_monitoring/ApprovalMonitorViewPage';
import ApprovalMonitorLegacyRedirectPage from './pages/approval_monitoring/ApprovalMonitorLegacyRedirectPage';
import ObtainorderStaticsPage from './pages/obtainorder_statics/ObtainorderStaticsPage';
import ProjectOrdersListPage from './pages/project_orders/ProjectOrdersListPage';
import AccountSalesManageViewPage from './pages/account-sales-manage-statics/AccountSalesManageViewPage';
import SalesManageViewPage from './pages/sales-manage-statics/SalesManageViewPage';

import IndividualSalaryInputPage from './pages/budget-manage/IndividualSalaryInputPage';
import IndividualDirectcostbudgetPage from './pages/budget-manage/IndividualDirectcostbudgetPage';
import TotalOverheadBudgetInputPage from './pages/budget-manage/TotalOverheadBudgetInputPage';
import HeadquarterBudgetInputPage from './pages/budget-manage/HeadquarterBudgetInputPage';
import TeamBudgetInputPage from './pages/budget-manage/TeamBudgetInputPage';
import SalesMngCostStatsPage from './pages/sales_mng_cost_stats/SalesMngCostStatsPage';
import CommonCostStatsPage from './pages/common-cost-stats/CommonCostStatsPage';
import SalesCostManageListPage from './pages/sales-cost-manage/SalesCostManageListPage';

import BillsAccountsPage from './pages/balance-accounts/BillsAccountsPage';
import ForecastResultsPage from './pages/balance-accounts/ForecastResultsPage';
import MonthsAccountsPage from './pages/balance-accounts/MonthsAccountsPage';
import Top50CompanyAccountsPage from './pages/balance-accounts/Top50CompanyAccountsPage';
import GroupsAccountsPage from './pages/balance-accounts/GroupsAccountsPage';

import MainchatViewPage from './pages/mainchat/MainchatViewPage';
import ManufacturingMngPage from './pages/manufacturingmng/ManufacturingMngPage';
import ManufacturingListPage from './pages/manufacturingmng/ManufacturingListPage';
import ProjectPlansPage from './pages/manufacturingmng/ProjectPlansPage';
import ManufacturingDetailPage from './pages/manufacturingmng/ManufacturingDetailPage';
import ProcessTemplatePage from './pages/manufacturingmng/ProcessTemplatePage';
import WorkflowPage from './pages/manufacturingmng/WorkflowPage';
import ProcessMasterPage from './pages/manufacturingmng/ProcessMasterPage';

// 출고관리
import ShipmentMngPage from './pages/shipmentmng/ShipmentMngPage';
import ShipmentMngListPage from './pages/shipmentmng/ShipmentMngListPage';
import ShipmentCandidateListPage from './pages/shipmentmng/ShipmentCandidateListPage';

// 목표 관리
import TargetMngPage from './pages/targetmng/TargetMngPage';
import TargetFormContainer from './containers/targetmng/TargetFormContainer';
import TargetKpiSettingPage from './pages/targetmng/TargetKpiSettingPage';
import KpiReportPage from './pages/targetmng/KpiReportPage';
import KpiDashboardPage from './pages/kpimng/KpiDashboardPage';
import MainDashboardPage from './pages/main/MainDashboardPage';

// UI 비교 데모 페이지
import OrderBookUIComparePage from './pages/ui_demo/OrderBookUIComparePage';
import IntentBotTestPage from './pages/test/IntentBotTestPage';

// 근태 관리
import AttendMngPage from './pages/attendancemng/AttendMngPage';

// 장비 관리
import EqpMngPage from './pages/eqpmng/EqpMngPage';
import EqpAgentMngPage from './pages/eqpmng/EqpAgentMngPage';
import EqpMonitorMngPage from './pages/eqpmng/EqpMonitorMngPage';
import ProductionStatusPage from './pages/production_status/ProductionStatusPage';
import EqpDataMngPage from './pages/eqpmng/EqpDataMngPage';


function PrivateOutlet() {
  const auth = localStorage.getItem('access_token');
  return auth ? <MainPage /> : <Navigate to="/login" replace />;
}

const App = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <NativeDownloadToastBridge />
      <NativePushBridge />
      <BiometricLockScreen />
      <Routes>
        <Route path="/" element={<PrivateOutlet />}>
          <Route index element={<Navigate to="/maindashboard" />} />

          <Route path="dashboard" element={<DashboardMngPage />}>
            <Route index element={<DashboardViewPage />} />
          </Route>


          <Route path="maindashboard" element={<MainDashboardPage />} />

          <Route path="mainchat" element={<MainchatViewPage />}>
            <Route index element={<MainchatViewPage />} />
          </Route>

          <Route path="partnermng" element={<PartnerMngPage />}>
            <Route index element={<PartnerListPage />} />
            <Route path="add" element={<PartnerAddPage />} />
            <Route path=":id" element={<PartnerViewPage />} />
            <Route path=":id/edit" element={<PartnerEditPage />} />
          </Route>

          <Route path="employeemng" element={<EmployeeMngPage />}>
            <Route index element={<EmployeeListPage />} />
            <Route path="add" element={<EmployeeAddPage />} />
            <Route path=":id" element={<EmployeeViewPage />} />
            <Route path=":id/edit" element={<EmployeeEditPage />} />
          </Route>

          {/* 포캐스팅 관리 */}
          <Route
            path="forecastmonthstat"
            element={<ForecastMonthStatMngPage />}
          >
            <Route index element={<ForecastMonthStatViewPage />} />
          </Route>
          <Route path="forecaststat" element={<ForecastStatMngPage />}>
            <Route index element={<ForecastStatViewPage />} />
          </Route>

          <Route path="add" element={<ChanceAddPage />} />


          {/*
            번호 하나로 들어오는 단 하나의 입구. 목적지는 서버가 상태를 보고 정한다.
            아래 chancemng/no, chancemng/order-no 는 이미 공유된 주소를 위해 남겨 둔다.
          */}
          <Route path="go/:no" element={<GoPage />} />

          <Route path="chancemng" element={<ChanceMngPage />}>
            <Route index element={<ChanceListPage />} />
            <Route path="add" element={<ChanceAddPage />} />
            <Route path="addForecast" element={<ChanceAddForecastPage />} />
            {/* 번호로 여는 진입점. :id 보다 먼저 와야 "no" 가 UUID 로 먹히지 않는다. */}
            {/* 묶음. :id 보다 앞에 와야 "groups" 가 UUID 로 먹히지 않는다. */}
            <Route path="groups" element={<GroupListPage />} />
            <Route path="groups/:groupUuid" element={<GroupDetailPage />} />

            <Route path="no/:prjNo" element={<ChanceByNoPage />} />
            <Route path="order-no/:roNo" element={<ChanceByNoPage kind="ro" />} />
            <Route path=":id" element={<ChanceDetailPage />}>
              <Route path=":step/:tab" element={<ChanceStepPage />} />
            </Route>
          </Route>

          {/* 2026-10-11: 수주 실패는 더 이상 별도 메뉴가 아니라 영업 진행 현황의
              토글이다. 기존 /chance-fail 링크(북마크·알림)는 계속 동작하도록 리다이렉트만 둔다. */}
          <Route path="chance-fail" element={<Navigate to="/chancemng?view=fail" replace />} />

          {/* 2026-10-11: 매출/매입 견적서·발주서 현황이 "견적서 현황"/"발주서 현황" 탭 화면으로
              합쳐졌다. 기존 주소(북마크·공유 링크·알림)는 탭이 선택된 상태로 그대로 이어지게
              리다이렉트만 남긴다. */}
          <Route path="estimate_status" element={<EstimateStatusPage />} />
          <Route path="order_sheet_status" element={<OrderSheetStatusPage />} />
          <Route path="sales_estimate" element={<Navigate to="/estimate_status?tab=sales" replace />} />
          <Route path="buys_estimate" element={<Navigate to="/estimate_status?tab=buys" replace />} />
          <Route path="sales_order_sheet" element={<Navigate to="/order_sheet_status?tab=sales" replace />} />
          <Route path="buys_order_sheet" element={<Navigate to="/order_sheet_status?tab=buys" replace />} />

          {/* 도면 견적(시범) - 3D 설계파일(STEP)로 견적 초안을 뽑아보는 프로토타입 */}
          <Route path="cadquote" element={<CadQuotePage />} />

          {/* 수주 관리 */}
          <Route
            path="obtainorder_statics"
            element={<ObtainorderStaticsPage />}
          />
          <Route path="project_orders">
            <Route index element={<ProjectOrdersListPage />} />
          </Route>
          <Route path="project_dept_stat" element={<ProjectDeptStatMngPage />}>
            <Route index element={<ProjectDeptStatViewPage />} />
          </Route>
          <Route
            path="maintance_dept_stat"
            element={<MaintanceDeptStatMngPage />}
          >
            <Route index element={<MaintanceDeptStatViewPage />} />
          </Route>

          <Route
            path="project_dept_count"
            element={<ProjectDeptCountMngPage />}
          >
            <Route index element={<ProjectDeptCountViewPage />} />
          </Route>
          <Route path="vendor_dept_stat" element={<VendorDeptStatMngPage />}>
            <Route index element={<VendorDeptStatViewPage />} />
          </Route>

          <Route path="projectmng" element={<ProjectMngPage />}>
            <Route index element={<ProjectListPage />} />
            <Route path=":id" element={<ProjectDetailPage />}>
              <Route path=":step/:tab" element={<ProjectStepPage />} />
            </Route>
          </Route>

          <Route path="maintancetmng" element={<MaintanceMngPage />}>
            {/* 2026-10-19 메뉴 통합: 목록은 계약 관리(/projectmng)로 합쳤다.
                상세/스텝 딥링크는 그대로 둔다 - 기존 북마크·알림 링크 호환. */}
            <Route index element={<Navigate to="/projectmng?type=maint" replace />} />
            <Route path=":id" element={<MaintanceDetailPage />}>
              <Route path=":step/:tab" element={<MaintanceStepPage />} />
            </Route>
          </Route>

          {/* 세금계산서 관리 */}

          {/* 세금계산서 흐름(new) — 기존 3개 모듈 병행 운영, 검증 후 컷오버 예정 */}
          <Route path="billflow" element={<BillFlowMngPage />}>
            <Route index element={<BillFlowListPage />} />
            <Route path=":id" element={<BillFlowDetailPage />} />
          </Route>

          <Route path="paymentmng" element={<PaymentMngPage />}>
            <Route index element={<PaymentListPage />} />
            <Route path="add" element={<PaymentAddPage />} />
            <Route path=":id" element={<PaymentViewPage />} />
            <Route path=":id/edit" element={<PaymentEditPage />} />
          </Route>

          <Route path="taxbillmng" element={<TaxbillMngPage />}>
            <Route index element={<TaxbillListPage />} />
            <Route path="add" element={<TaxbillAddPage />} />
            <Route path=":id" element={<TaxbillViewPage />} />
            <Route path=":id/edit" element={<TaxbillEditPage />} />
          </Route>

          {/** 수금/지급 내역 (부분 수금 이력 조회 + 엑셀) */}
          <Route path="billcollect">
            <Route index element={<BillCollectListPage />} />
          </Route>

          {/** 채권/채무관리 */}
          <Route path="bonds-depts">
            <Route index element={<BondDeptListPage />} />
          </Route>
          <Route path="collects-buys">
            <Route index element={<CollectBuyListPage />} />
          </Route>

          <Route path="taxIssuedmng" element={<TaxIssuedMngPage />}>
            <Route index element={<TaxIssuedListPage />} />
            <Route path="add" element={<TaxIssuedAddPage />} />
            <Route path=":id" element={<TaxIssuedViewPage />} />
            <Route path=":id/edit" element={<TaxIssuedEditPage />} />
          </Route>

          <Route path="salesgoalmng" element={<SaleGoalMngPage />}>
            <Route index element={<SaleGoalViewPage />} />
            <Route path="edit" element={<SaleGoalEditPage />} />
          </Route>

          {/* 기술지원 */}
          <Route path="techmng" element={<TechMngPage />}>
            <Route index element={<TechProjectListPage />} />
            <Route path=":id" element={<TechProjectDetailPage />}>
              <Route path=":step/:tab" element={<TechStepPage />} />
            </Route>
          </Route>

          <Route path="reqtechmng" element={<ReqTechMngPage />}>
            <Route index element={<ReqTechListPage />} />
            <Route path=":id" element={<ReqTechViewPage />} />
          </Route>

          <Route path="plantechmng" element={<PlanTechMngPage />}>
            <Route index element={<PlanTechListPage />} />
            <Route path=":id" element={<PlanTechViewPage />} />
          </Route>

          <Route path="rslttechmng" element={<RsltTechMngPage />}>
            <Route index element={<RsltTechListPage />} />
            <Route path=":id" element={<RsltTechViewPage />} />
          </Route>

          {/* 결산관리 */}
          {/* <Route path="techstat" element={<TechStatMngPage />}>
            <Route index element={<TechStatViewPage />} />
          </Route> */}

          <Route path="groups-accounts" element={<GroupsAccountsPage />} />
          <Route path="bills-accounts" element={<BillsAccountsPage />} />
          <Route
            path="top50-company-accounts"
            element={<Top50CompanyAccountsPage />}
          />
          <Route path="months-accounts" element={<MonthsAccountsPage />} />
          <Route path="forecast-results" element={<ForecastResultsPage />} />

          <Route path="sales-statics" element={<SalesStaticsViewPage />} />

          <Route
            path="account-sales-manage-statics"
            element={<AccountSalesManageViewPage />}
          />
          <Route
            path="sales-manage-statics"
            element={<SalesManageViewPage />}
          />
          <Route path="common-cost-stats" element={<CommonCostStatsPage />} />

          {/* 판매관리비 관리 */}
          <Route
            path="sales-cost-manage"
            element={<SalesCostManageListPage />}
          />

          <Route
            path="sales-mng-cost-stats"
            element={<SalesMngCostStatsPage />}
          />
          <Route path="goal_statics" element={<GoalStaticsMngPage />}>
            <Route index element={<GoalStaticsViewPage />} />
          </Route>

          <Route path="taxbill_statics" element={<TaxbillStaticsMngPage />}>
            <Route index element={<TaxbillStaticsViewPage />} />
          </Route>

          <Route path="bonds-depts-statics">
            <Route index element={<BondsDeptsStaticsViewPage />} />
          </Route>

          <Route path="collects-buys-statics">
            <Route index element={<CollectsBuysStaticsViewPage />} />
          </Route>

          {/* 결산 관리 */}
          <Route
            path="salesman-statics"
            element={<SalesmanStaticsViewPage />}
          />

          <Route
            path="individual-salary-input"
            element={<IndividualSalaryInputPage />}
          />
          <Route
            path="individual-directcost-budget"
            element={<IndividualDirectcostbudgetPage />}
          />
          <Route
            path="total-overhead-budget-input"
            element={<TotalOverheadBudgetInputPage />}
          />
          <Route
            path="headquarter-budget-input"
            element={<HeadquarterBudgetInputPage />}
          />
          <Route path="team-budget-input" element={<TeamBudgetInputPage />} />

          {/* 목표 설정 */}
          <Route path="goalsetting" element={<GoalSettingMngPage />}>
            <Route path=":deptId" element={<GoalDeptUserPage />}>
              <Route path=":id" element={<GoalSettingPage />} />
            </Route>
          </Route>

          {/* 제품관리 */}
          <Route path="productmng" element={<ProductMngPage />}>
            <Route index element={<ProductListPage />} />
            <Route path="add" element={<ProductAddPage />} />
            <Route path=":id" element={<ProductViewPage />} />
            <Route path=":id/edit" element={<ProductEditPage />} />
          </Route>

          <Route path="inventorymng" element={<WarehouseListPage />} />
          <Route path="inventorymng/:whUuid" element={<InventoryMngPage />}>
            <Route index element={<InventoryProductsPage />} />
            <Route path="history" element={<InventoryHistoryPage />} />
          </Route>

          <Route path="profile" element={<ProfileMngPage />}>
            <Route index element={<ProfileViewPage />} />
            <Route path="edit" element={<ProfileEditPage />} />
          </Route>

          {/* 공통관리 */}
          <Route path="codemng" element={<CodeMngPage />} />
          <Route path="fieldconfigmng" element={<FieldConfigPage />} />
          <Route path="companyinfomng" element={<CompanyInfoPage />} />
          <Route path="sysjobs" element={<SysJobsPage />} />

          <Route path="deptmng" element={<DeptMngPage />}>
            <Route path=":id" element={<DeptViewPage />} />
            <Route path=":id/edit" element={<DeptEditPage />} />
          </Route>

          <Route path="authmenumng" element={<Navigate to="/menumng" replace />} />
          <Route path="authmenumng/*" element={<Navigate to="/menumng" replace />} />
          <Route path="usermenumng" element={<Navigate to="/menumng" replace />} />

          {/* 파일 찾기 — 영업·제조 가리지 않고 */}
          <Route path="filemng" element={<FileSearchPage />} />

          <Route path="menumng" element={<MenuMngPage />}>
            <Route index element={<MenuEditPage />} />
          </Route>

          <Route path="approvalmng" element={<ApprovalMngPage />}>
            <Route index element={<Navigate to="inbox" replace />} />
            <Route path="submitted" element={<ApprovalSubmittedPage />} />
            <Route path="inbox" element={<ApprovalListPage />} />
            <Route path="lines" element={<ApprovalLineTemplatePage />} />
            <Route path="delegations" element={<ApprovalDelegationPage />} />
            <Route path="auths" element={<ApprovalFinalAuthPage />} />
            <Route path="monitoring" element={<ApprovalMonitorListPage />} />
            <Route path="monitoring/:id" element={<ApprovalMonitorViewPage />} />
            <Route path=":id" element={<ApprovalViewPage />} />
          </Route>

          <Route path="approval_monitoring" element={<Navigate to="/approvalmng/monitoring" replace />} />
          <Route path="approval_monitoring/:id" element={<ApprovalMonitorLegacyRedirectPage />} />

          <Route path="schedulemng" element={<ScheduleMngPage />}>
            <Route index element={<Navigate to="sales" replace />} />
            <Route path="sales" element={<SalesSchedulePage />} />
            <Route
              path="manufacturing"
              element={<ManufacturingSchedulePage />}
            />
          </Route>

          <Route path="noticemng" element={<NoticeMngPage />}></Route>
          <Route path="esgmng" element={<EsgMngPage />}></Route>

          {/* 제조관리 */}
          <Route path="manufacturingmng" element={<ManufacturingMngPage />}>
            <Route index element={<ManufacturingListPage />} />
            <Route path=":projectId/plans" element={<ProjectPlansPage />} />
            <Route path=":projectId/plans/:planId" element={<ManufacturingDetailPage />} />
          </Route>

          {/* 워크플로우 관리 */}
          <Route path="manufacturingmng/workflow" element={<WorkflowPage />} />

          {/* 생산 공정 템플릿 관리 */}
          <Route path="processtemplate" element={<ProcessTemplatePage />} />

          {/* 공정 마스터 관리 */}
          <Route path="manufacturingmng/process" element={<ProcessMasterPage />} />

          {/* 출고관리 */}
          <Route path="shipmentmng" element={<ShipmentMngPage />}>
            <Route index element={<ShipmentMngListPage />} />
            <Route path="candidates" element={<ShipmentCandidateListPage />} />
          </Route>

          {/* 목표 관리 */}
          <Route path="targetmng" element={<TargetMngPage />}>
            <Route path=":targetTyp/:deptId" element={<TargetFormContainer />} />
          </Route>
          <Route path="targetmng/kpi-setting" element={<TargetKpiSettingPage />} />
          <Route path="targetmng/kpi-report" element={<KpiReportPage />} />
          <Route path="kpimng" element={<KpiDashboardPage />} />
          <Route path="kpi-production" element={<Navigate to="/kpimng?tab=production" replace />} />
          <Route path="kpi-quality" element={<Navigate to="/kpimng?tab=quality" replace />} />
          <Route path="kpi-delivery" element={<Navigate to="/kpimng?tab=delivery" replace />} />
          <Route path="kpi-cost" element={<Navigate to="/kpimng?tab=cost" replace />} />

          {/* 근태 관리 */}
          <Route path="attendancemng" element={<AttendMngPage />} />

          {/* 장비 관리 */}
          <Route path="eqpmng" element={<EqpMngPage />} />
          <Route path="eqpmng/agent" element={<EqpAgentMngPage />} />
          {/* 2026-10-11: 장비 모니터링 단독 메뉴(2005)는 "생산 현황" 탭으로 들어갔다.
              컴포넌트/주소는 그대로 유지한다(생산 현황 안에서도 이 컴포넌트를 그대로 그림). */}
          <Route path="eqpmng/monitor" element={<EqpMonitorMngPage />} />
          <Route path="eqpmng/data" element={<EqpDataMngPage />} />

          {/* 생산 현황(신규): 장비 모니터링 + 공정 진행 탭 */}
          <Route path="production-status" element={<ProductionStatusPage />} />
          <Route path="eqp-codemng" element={<Navigate to="/codemng" replace />} />

          {/* UI 비교 데모 페이지 */}
          <Route path="ui-demo/order-book" element={<OrderBookUIComparePage />} />
          <Route path="test/intent-bot" element={<IntentBotTestPage />} />
        </Route>

        <Route path="login" element={<LoginPage />} />
        <Route
          path="*"
          element={
            <main style={{ padding: '1rem' }}>
              <p>There's nothing here!</p>
            </main>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default App;
